import React from "react";

import { ProtocolEditBriefContainer } from "../../containers/Protocols/Brief/EditBrief";

export const ProtocolEditView = props => {
    const { match: { params } } = props;

    return (<ProtocolEditBriefContainer protocolId={params.protocolId} />);
}